import { define } from '@rlean/core';

const UserDescription = define('userDescription', {
  initialState: {},
  getURL: '/UserDescription/:oid',
});

export default UserDescription;
